import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/finish`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/finish`;

export const URL = (jobId: number): RouteDefinition =>
	`${baseRoute}/${jobId}/finish`;
